import React from 'react';
import styles from './Overlay.module.scss';
import Busy from '../Busy';

export const Overlay = () => {
  return (
    <div className={styles.overlayContainer}>
      <Busy darkBackground />
    </div>
  );
};

export default Overlay;
